import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class CategoryShowcaseComponent extends Component {
  #io = null;

  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) {
      this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
      return;
    }
    this.#io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); this.#io?.unobserve(e.target); }
      }
    }, { rootMargin: '0px 0px -10% 0px' });
    this.querySelectorAll('.reveal').forEach((el) => this.#io.observe(el));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#io?.disconnect();
  }
}

if (!customElements.get('category-showcase-component')) {
  customElements.define('category-showcase-component', CategoryShowcaseComponent);
}
